export const USER_PROFILE_KEY = 'userProfile';
export const USER_PROFILE_CACHE_KEY = 'userProfileCache';
export const USER_PROFILE_CACHE_SCHEMA_VERSION = 1;

const normalize = (value) => String(value || '').trim();
const normalizeEmail = (value) => normalize(value).toLowerCase();

export function getCurrentProfileOwner() {
  return {
    userId: normalize(localStorage.getItem('userId')),
    email: normalizeEmail(localStorage.getItem('userEmail'))
  };
}

export function writeOwnedUserProfileCache(profile, owner = getCurrentProfileOwner()) {
  if (!profile || typeof profile !== 'object' || Array.isArray(profile)) return;
  const ownerUserId = normalize(owner.userId);
  const ownerEmail = normalizeEmail(owner.email);
  localStorage.removeItem(USER_PROFILE_KEY);
  localStorage.setItem(USER_PROFILE_CACHE_KEY, JSON.stringify({
    schemaVersion: USER_PROFILE_CACHE_SCHEMA_VERSION,
    ownerUserId,
    ownerEmail,
    cachedAt: Date.now(),
    profile
  }));
}

export function readOwnedUserProfileCache(owner = getCurrentProfileOwner()) {
  try {
    const expectedUserId = normalize(owner.userId);
    const expectedEmail = normalizeEmail(owner.email);
    const envelopeCached = localStorage.getItem(USER_PROFILE_CACHE_KEY);

    if (envelopeCached) {
      const envelope = JSON.parse(envelopeCached);
      if (envelope?.schemaVersion !== USER_PROFILE_CACHE_SCHEMA_VERSION) return null;
      const ownerUserId = normalize(envelope?.ownerUserId);
      const ownerEmail = normalizeEmail(envelope?.ownerEmail);
      const profile = envelope?.profile;
      if (!profile || typeof profile !== 'object' || Array.isArray(profile)) return null;
      if (!ownerUserId || !ownerEmail) return null;
      if (expectedUserId && ownerUserId !== expectedUserId) return null;
      if (expectedEmail && ownerEmail !== expectedEmail) return null;
      return profile;
    }

    const legacyCached = localStorage.getItem(USER_PROFILE_KEY);
    const profile = legacyCached ? JSON.parse(legacyCached) : null;
    if (!profile || typeof profile !== 'object' || Array.isArray(profile)) return null;

    const profileUserId = normalize(
      profile.userId ||
      profile.id ||
      profile.studentId ||
      profile.studentUserId ||
      profile.parentId ||
      profile.tutorId
    );
    const profileEmail = normalizeEmail(
      profile.email ||
      profile.userEmail ||
      profile.studentEmail ||
      profile.parentEmail ||
      profile.tutorEmail
    );

    if (expectedUserId && !profileUserId) return null;
    if (expectedEmail && !profileEmail) return null;
    if (expectedUserId && profileUserId !== expectedUserId) return null;
    if (expectedEmail && profileEmail !== expectedEmail) return null;

    return profile;
  } catch {
    return null;
  }
}

export function clearUserProfileCache() {
  localStorage.removeItem(USER_PROFILE_KEY);
  localStorage.removeItem(USER_PROFILE_CACHE_KEY);
}
